import type { SVGProps } from "react";
import type { FC } from 'react';
import styled from 'styled-components';
import { iconSizeMap } from '../utils/size-map';
import type { IconSize, TokenSizeProps } from '../utils/type';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<TokenSizeProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><g fill="currentColor" clipPath="url(#award_svg__a)"><path d="M18 8A6 6 0 1 0 6 8a6 6 0 0 0 12 0m2 0A8 8 0 1 1 4 8a8 8 0 0 1 16 0" /><path d="M15.658 12.889a1 1 0 0 1 1.105.759l.018.1 1.21 9.12a1 1 0 0 1-1.506.99L12 21.166l-4.485 2.692a1 1 0 0 1-1.506-.99l1.21-9.11a1 1 0 0 1 1.982.264l-.937 7.053 3.221-1.932.122-.063a1 1 0 0 1 .908.063l3.22 1.933-.936-7.064-.009-.103a1 1 0 0 1 .868-1.02M9.707 8.95a1 1 0 0 1 0-1.414m4.243-1.414a1 1 0 0 1 1.414 0" /></g><defs><clipPath id="award_svg__a"><path fill="currentColor" d="M0 0h24v24H0z" /></clipPath></defs></svg>;
const Wrapper = styled.span<{
  $size?: IconSize;
}>`
  width: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  height: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  display: inline-block;
  vertical-align: middle;
`;
const SvgAward = ({
  $size,
  ...rest
}: TokenSizeProps) => <Wrapper $size={$size} className="mnd-icon"><SvgBase {...rest} /></Wrapper>;
export default SvgAward;